import {
  Box,
  Text,
  Flex,
  Spacer,
  HStack,
  useTheme,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CustomTable from "../../../components/table/customTable/CustomTable";
import AddPackageModal from "../../../components/modals/AddModals/AddPackageModal";
import { useDisclosure } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getAllpackages } from "../../../store/slice/packageSlice";
const Package = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { packages, status } = useSelector((state) => state.packages);
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(5);
  useEffect(() => {
    dispatch(getAllpackages());
  }, [dispatch]);

  const handleAddChapter = () => {
    setEditData(null);
    onOpen();
  };

  const handleEditChapter = (id) => {
    const selectedChapter = packages.find((chapter) => chapter.id === id);
    if (selectedChapter) {
      setEditData(selectedChapter);
      onOpen();
    }
  };

  const filteredChapter = packages?.filter((course) =>
    course?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box w={"100%"}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Packages
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Packages"} onClick={handleAddChapter} />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        <SearchBox onSearch={setSearchTerm} />
      </Flex>
      <Box overflow={"scroll"}>
        {status === "loading" ? (
          <Box
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner size="md" color="blue.500" />
          </Box>
        ) : status === "failed" ? (
          <Text>Failed to load packages</Text>
        ) : (
          <CustomTable
            data={filteredChapter.slice(0, limit)}
            entityType="package"
            onEdit={handleEditChapter}
            extraColumns={[]}
            limit={limit}
          />
        )}
      </Box>

      <AddPackageModal isOpen={isOpen} onClose={onClose} editData={editData} />
    </Box>
  );
};

export default Package;
